import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Updated imports
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import AddBanner from "./Components/AddBanner";
import Banner from "./Components/Banner";
import AddReviews from "./Components/AddReviews";
import Reviews from "./Components/Reviews";
import CarsMaker from "./Components/CarsMaker";
import AllVehicles from "./Components/AllVehicles";
import ThirdPartyVehicles from "./Components/ThirdPartyVehicles";
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import Home from "./Components/Home";
import AboutUs from "./Components/AboutUs";
import MissionVision from "./Components/MissionVision";
import Terms from "./Components/Terms";
import WhyChooseUs from "./Components/WhyChooseUs";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import CompanyProfile from "./Components/CompanyProfile";
import HowToBuy from "./Components/HowToBuy";
import SearchCars from "./Components/SearchCars";
import Contact from "./Components/Contact";
import Login from "./Components/Login";
import AdminPanel from "./Components/AdminPanel";
import Register from "./Components/Register";
import BankingDetails from "./Components/BankingDetails";
import Auction from "./Components/Auction";
import ChassisCheck from "./Components/ChassisCheck";
import Shipping from "./Components/Shipping";
import CarReviews from "./Components/CarReviews";
import FAQPage from "./Components/FAQPage";
import ViewUser from "./Components/ViewUser";
import CreateAccount from "./Components/CreateAccount";
import AddVehicle from "./Components/AddVehicle";
import Vehicles from "./Components/Vehicles";
import AddVehicleThirdparty from "./Components/AddThirdParty";
import ThirdParty from "./Components/ThirdParty";
import CarManagementSystem from "./Components/CarManagementSystem";
import EditVehicles from "./Components/EditVehicles";
import EditVehiclesThirdParty from "./Components/EditVehiclesThirdParty";
import VehicleDetails from "./Components/VehicleDetails";
import SearchResult from "./Components/SearchResult";
import SearchIndividual from "./Components/SearchIndividual";
import Portfolio from "./Components/Portfolio";
import AddSale from "./Components/AddSale";
import ViewSales from "./Components/ViewSales";
import ViewPurchase from "./Components/ViewPurchase";
import Accounts from "./Components/Accounts";
import DocsShip from "./Components/DocsShip";
import ViewPayments from "./Components/ViewPayments";
import VehiclesCost from "./Components/VehiclesCost";
import ViewVolet from "./Components/ViewVolet";
import CreateVolet from "./Components/CreateVolet";
import AllocatedPayments from "./Components/AllocatedPayments";
import CreateAllocate from "./Components/CreateAllocate";
import AllocateVehicle from "./Components/AllocateVehicle";
import ClientAccounts from "./Components/ClientAccounts";
import PurchasedVehicles from "./Components/PurchasedVehicles";
import VehicleImages from "./Components/VehicleImages";
import ViewDocs from "./Components/ViewDocs";
import SearchVehicle from "./Components/SearchVehicle";
import Invoice from "./Components/Invoice";
import InvoicePreview from './Components/InvoicePreview'; // Add this import
import PurchasedImages from './Components/PurchasedImages';
import ViewPurchaseDocs from './Components/ViewPurchaseDocs';
import RefundAmount from './Components/RefundAmount';
import PanelAuction from './Components/PanelAuction';
import CalculatorEdit from './Components/CalculatorEdit';
import ReviewCarousel from "./Components/ReviewCarousel";

function App() {
  return (
    <Router> {/* Use BrowserRouter as Router */}
        <div className="container text-center py-5">
          <h1 className="display-1">404</h1>
          <h2>Page Not Found</h2>
          <p>The page you are looking for doesn't exist.</p>
      </div>
    </Router>
  );
}

export default App;
